import { activateInlineScripts } from '@otto-ec/global-resources/dom';
import { BaseComponent } from '../../base-component';

export class PdpContentComponent extends BaseComponent {
    public rootSelector = '.js_pdp_pdp-content';
    private isInitialPageLoad = true;

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }
        const rootElement = this.getRootElement();
        if (rootElement.dataset.newDescription === 'true' && !this.isInitialPageLoad) {
            const descriptionElement = rootElement.querySelector<HTMLElement>('.pdp_description');
            if (descriptionElement) {
                await activateInlineScripts(descriptionElement);
            }
        }
        this.isInitialPageLoad = false;
    }
}
